
import { common as deCommon } from './de/common';
import { common as enCommon } from './en/common';

const messages = {
  de: {
    translation: {
      ...deCommon,
    },
  },
  en: {
    translation: {
      ...enCommon,
    },
  },
};

export default messages;
